// extracted by mini-css-extract-plugin
export var autoExpand = "_2z-8";
export var container = "_2z-7";
export var containerWidth = "_2z-5";
export var disabled = "_2z-2";
export var error = "_2z-3";
export var fullWidth = "_2z-6";
export var inputWrapper = "_2z-0";
export var small = "_2z-1";
export var textarea = "_2z-4";